var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"my-2",attrs:{"no-body":"","header":_vm.header}},[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.data),function(d){return _c('b-list-group-item',{key:d.name,attrs:{"href":d.url ? d.url : ''}},[_vm._v(_vm._s(d.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }